"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const GroupedPublishersFooter = (props) => {
    const { totalShares } = props;
    return (react_1.default.createElement("div", { className: 'grouped-publishers-footer' },
        react_1.default.createElement("p", null, "Total Submitted Shares"),
        react_1.default.createElement("p", { className: (0, clsx_1.default)(totalShares <= 100.06 ? 'green' : 'red') }, totalShares.toFixed(2) + '%')));
};
exports.default = GroupedPublishersFooter;
